//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.0.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export interface IRPFConcept {
    label: string;
    valuePerIRPFType: { [key in keyof typeof IRPFConceptType]?: number; };
    isSingleRow: boolean;
}

export enum IRPFConceptType {
    DirectEstimation = 0,
    SimplifiedDirectEstimation = 1,
    ObjectiveEstimation = 2,
    ObjectiveEstimationAgriculturalLivestockForestry = 3,
}

export interface IRPFCategory {
    label: string;
    concepts: IRPFConcept[];
}